import React from 'react'
import { AutocompleteInputProps, AutocompleteArrayInput } from 'react-admin'
import LocalizedFieldWithChoices from './LocalilzedFieldWithChoices'

type Props = AutocompleteInputProps

const LocalizedAutoCompleteArrayInput: React.FC<Props> = (props) => (
  <LocalizedFieldWithChoices {...props}>
    <AutocompleteArrayInput />
  </LocalizedFieldWithChoices>
)

export default LocalizedAutoCompleteArrayInput
